var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLevelHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 128,
    viewBox: "0 0 119 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4272 5.64941C56.1267 1.86348 63.5403 1.86348 69.2397 5.64941L106.442 30.3613C110.871 33.3036 113.668 38.1491 114.001 43.4561L116.802 88.0293C117.231 94.858 113.524 101.278 107.396 104.321L67.394 124.184C62.6313 126.548 57.0357 126.548 52.2729 124.184L12.271 104.321C6.33425 101.373 2.67054 95.2558 2.8374 88.668L2.86475 88.0293L5.66553 43.4561C5.99891 38.1491 8.79595 33.3036 13.2251 30.3613L50.4272 5.64941Z",
    stroke: "url(#paint0_linear_17748_1779)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17748_1779",
    x1: 123.435,
    y1: 11.5227,
    x2: 0.873979,
    y2: 134.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F3795E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#E4BC5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#39D68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#37B1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#874FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05576"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLevelHighlight);
export default __webpack_public_path__ + "static/media/current-level-highlight.b6ab541df9c8171137a33293b5993258.svg";
export { ForwardRef as ReactComponent };